import React from "react";
import { Link } from "react-router-dom";
import { Youtube, Facebook, Instagram, BookOpen, ArrowUpRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useData } from "../context/DataContext";
import { CONTACT, LOGO } from "../mock/mock";
import OfficeCards from "./OfficeCards";
import { trackEvent } from "../lib/track";

const Footer = () => {
  const { tr, ui } = useLang();
  const { categories } = useData();
  return (
    <footer className="bg-[#211d18] text-[#e8e0d4]">
      <div className="max-w-[1360px] mx-auto px-5 md:px-8 py-16 grid grid-cols-1 md:grid-cols-[0.95fr_0.8fr_0.95fr_1.5fr] gap-x-8 gap-y-10">
        <div className="md:col-span-1">
          <img src={LOGO} alt="HAAS Mosaic" className="h-12 w-auto mb-5 brightness-0 invert" />
          <p className="text-[13px] leading-relaxed text-[#b5ab9b] max-w-xs">{ui.footerAbout}</p>
          <div className="flex flex-col gap-3 mt-6">
            {[
              { href: CONTACT.instagram, Icon: Instagram, label: "Instagram" },
              { href: CONTACT.youtube, Icon: Youtube, label: "YouTube" },
              { href: CONTACT.facebook, Icon: Facebook, label: "Facebook" },
            ].map(({ href, Icon, label }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-3 text-[12px] uppercase tracking-[0.16em] text-[#b5ab9b] hover:text-white transition-colors w-max">
                <span className="w-9 h-9 flex items-center justify-center border border-white/20 group-hover:border-[#a67c52] group-hover:bg-[#a67c52] transition-colors"><Icon size={16} /></span>
                {label}
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-[13px] uppercase tracking-[0.2em] text-white mb-5">{ui.nav.categories}</h4>
          <ul className="space-y-3 text-[13px] text-[#b5ab9b]">
            {categories.map((c) => (
              <li key={c.slug}><Link to={`/product-category/${c.slug}`} className="hover:text-white transition-colors">{tr(c.name)}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-[13px] uppercase tracking-[0.2em] text-white mb-5">{ui.nav.info}</h4>
          <ul className="space-y-3 text-[13px] text-[#b5ab9b]">
            <li><Link to="/" className="hover:text-white transition-colors">{ui.nav.home}</Link></li>
            <li><Link to="/all-projects" className="hover:text-white transition-colors">{ui.nav.projects}</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">{ui.nav.about}</Link></li>
            <li><Link to="/heritage" className="hover:text-white transition-colors">{ui.nav.heritage}</Link></li>
            <li><Link to="/how-we-do" className="hover:text-white transition-colors">{ui.nav.process}</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">{ui.nav.contact}</Link></li>
          </ul>

          <a href="/catalog/haas-2026-catalog.pdf" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent("catalog")} data-testid="footer-catalog" className="group mt-[18px] flex items-center justify-between gap-4 w-full max-w-[240px] border border-[#a67c52]/60 hover:border-[#a67c52] hover:bg-[#a67c52] px-4 py-3 transition-colors">
            <span className="flex items-center gap-3">
              <BookOpen size={18} className="text-[#a67c52] group-hover:text-white transition-colors" />
              <span className="flex flex-col leading-tight text-left">
                <span className="text-[9px] uppercase tracking-[0.18em] text-[#8b8271] group-hover:text-white/80 transition-colors">{tr({ en: "Discover", tr: "Keşfedin" })}</span>
                <span className="text-[12px] uppercase tracking-[0.14em] text-white">{tr({ en: "Online Catalogue", tr: "Online Katalog" })}</span>
              </span>
            </span>
            <ArrowUpRight size={16} className="text-[#b5ab9b] group-hover:text-white group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
          </a>
        </div>

        <div>
          <h4 className="text-[13px] uppercase tracking-[0.2em] text-white mb-5">{ui.contactUs}</h4>
          <OfficeCards variant="dark" />
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1360px] mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[12px] text-[#8b8271]">
          <p>© {new Date().getFullYear()} HAAS Mosaic — {ui.rights}</p>
          <p className="tracking-[0.14em] uppercase">Antioch Arts · Hatay</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
